import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TABLES } from '../../../../../Apis/Tables';
import { roleAvailableTasks } from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { useNavigate } from 'react-router-dom';
import PrivilegeDetails from '../Subcomponents/PrivilegeDetails';
import { permissionObj } from '../../../../../Helpers/permission';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import routes from '../../../../../Routes/routes';
import {
    DeleteIconsOptions,
    DetailsIconsOptions,
    IconPlusFill,
    IconSystem,
    PersonOutlinedChip,
    UpdateIconsOptions,
} from '../../../../../components/buttons/IconButtons';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import TableFunction from '../../../../../components/table/TableFunction';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import { toast } from 'react-toastify';
import { ROLE_NAME_DEFAULT_MODEL } from '../../../../../enums/userTypeEnum';
import { EMPTY_VALUES, errorMsg } from '../../../../../Apis/functions';
import CustomTooltip from '../../../../../components/CustomTooltip';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const RolesPanelLogic = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [selectRoleForDelete, setSelectRoleForDelete] = useState([]);
    const [roleShow, setRoleShow] = useState(false);
    const [modified, setModified] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState();
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [resultsToShow, setResultsToShow] = useState('');
    const option = TABLES.ROLE;
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: option });
        dispatch(roleAvailableTasks());
        dispatch(SimpleSearch({ body })).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setResultsToShow(data);
                }
            },
        );
    };

    const {
        handleCheckboxChange,
        handleDeleteAll,
        handleClose,
        pagination,
        page,
        rowsPerPage,
        openMenu,
        handleMenuToggle,
    } = TableFunction({
        selectedList: selectRoleForDelete,
        setSelectedList: setSelectRoleForDelete,
        data: resultsToShow,
        labelRowsPerPage: 'privileges_per_page',
        setIsAllChecked,
        fixedPagination: false,

        searchElement, //New
        getData, //New
        modified, //New
        setModified, //New
    });

    // api function to delete roles
    const deleteRoles = (deleteItem) => {
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName: TABLES.ROLE, body })).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success === true) {
                    setSelectRoleForDelete([]);
                    setIsAllChecked(false);
                    setModified(true);
                } else errorMsg(code);
            },
        );
    };

    const columns = [
        { field: 'name', label: 'name' },
        {
            field: 'name',
            label: 'systems/modules',
            render: (_, row) => {
                const permissions = row?.modules || [];
                if (!permissions.length) {
                    return (
                        <div className='d-flex justify-content-start align-items-center gap-2'>
                            <IconSystem className='h-16px w-16px icon-color-general-950' />
                            <span className='fs-14px ibl-font-w-400'>{EMPTY_VALUES.DEFAULT}</span>
                        </div>
                    );
                }
                const showCompactView = permissions.length >= 3;
                return (
                    <div className='d-flex flex-column gap-1'>
                        {!showCompactView &&
                            permissions.map((permission) => (
                                <div
                                    key={permission.id}
                                    className='d-flex justify-content-start align-items-center gap-2'
                                >
                                    <IconSystem className='h-16px w-16px icon-color-general-950' />

                                    <span className='fs-14px ibl-font-w-400 text-capitalize'>
                                        {t(permission.name).toLowerCase()}
                                    </span>
                                </div>
                            ))}

                        {showCompactView && (
                            <CustomTooltip
                                text={
                                    <div className='d-flex flex-column gap-1 gap-1 overflow-auto maxh-120px'>
                                        {permissions.map((permission) => {
                                            return (
                                                <span className='text-capitalize' key={permission.id}>
                                                    {t(permission.name).toLowerCase()}
                                                </span>
                                            );
                                        })}
                                    </div>
                                }
                            >
                                <div className='d-flex align-items-center gap-1 cursor-pointer'>
                                    <IconPlusFill className='h-16px w-16px icon-color-general-950' />

                                    <IconSystem className='h-16px w-16px icon-color-general-950' />
                                </div>
                            </CustomTooltip>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'users',
            label: 'users',
            render: (value, row) => {
                return (
                    <div className='d-flex justify-content-start align-items-center gap-2'>
                        <PersonOutlinedChip className='h-16px w-16px' />
                        <span className='fs-12px ibl-font-w-500'>{row.noEmployees}</span>
                    </div>
                );
            },
        },
    ];

    const handleRowExpand = (row) => {};

    const renderOptionsMenu = (row, index) => {
        const hasPermissionUpdate = permission?.includes(permissionObj?.WEB_PRIVILEGE_UPDATE);
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${row.id}`}>
                    {(DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_UPDATE)) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t(hasPermissionUpdate ? 'update' : 'details')}
                            click={() => navigate(`${routes.roles.update}${row?.id}`)}
                            icon={hasPermissionUpdate ? <UpdateIconsOptions /> : <DetailsIconsOptions />}
                        />
                    )}
                    {(DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_DELETE)) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t('delete')}
                            fontColor='font-color-error-600'
                            iconColor={'icon-color-error-code-600'}
                            icon={<DeleteIconsOptions />}
                            click={() => {
                                setSelectRoleForDelete([row?.id]);
                                setRoleShow(true);
                            }}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    };

    const handleDelete = () => {
        /**
         * Check if any of the selected role IDs correspond to a role
         * whose name is in ROLE_NAME_DEFAULT_MODEL
         */
        const hasExceptionRole = resultsToShow?.content?.some(
            (role) =>
                selectRoleForDelete.includes(role.id) && // if this role is selected
                Object.values(ROLE_NAME_DEFAULT_MODEL).includes(role.name?.toUpperCase()), // and it's an exception role
        );

        if (hasExceptionRole) {
            toast.error(t('you_cannot_delete_root_or_guard_roles'));
            return;
        }

        setRoleShow(true);
    };

    return {
        t,
        DEV,
        handleRowExpand,
        renderOptionsMenu,
        columns,
        handleCheckboxChange,
        deleteRoles,
        setIsAllChecked,
        selectRoleForDelete,
        roleShow,
        setRoleShow,
        searchElement,
        setSearchElement,
        option,
        page,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        setSelectRoleForDelete,
        permission,
        navigate,
        dispatch,
        resultsToShow,
        pagination,
        setResultsToShow,
        handleDeleteAll,
        PrivilegeDetails,
        setBodyForExport,
        handleDelete,
    };
};
export default RolesPanelLogic;
